import { Layout } from './layout';

Layout.displayName = 'Title';

export { Layout as Title };

export type { Props as TitleProps } from './types';
